import type { RouteObject } from 'react-router-dom'
import { Outlet } from 'react-router-dom'

const routes: RouteObject = {
  path: 'account-settings',
  lazy: async () => {
    const { AccountSettingsLayout } = await import('../../../features/account-settings')
    return {
      Component: () => (
        <AccountSettingsLayout>
          <Outlet />
        </AccountSettingsLayout>
      )
    }
  },
  children: [
    {
      index: true,
      lazy: async () => {
        const { AccountProfilePage } = await import('../../../features/account-settings')
        return { Component: AccountProfilePage }
      }
    },
    {
      path: 'change-password',
      lazy: async () => {
        const { AccountChangePasswordPage } = await import('../../../features/account-settings')
        return { Component: AccountChangePasswordPage }
      }
    },
    {
      path: 'mfa',
      lazy: async () => {
        const { AccountMfaPage } = await import('../../../features/account-settings')
        return { Component: AccountMfaPage }
      }
    }
  ]
}

export default routes
